import { t } from './i18n.es.js';
import fnsFormat from 'date-fns/format';
export { i as isBrowserShareAvailable, a as isTerraShareAvailable, s as share } from './browser-share-54252469.js';
import 'i18next';
import './lang.es.js';
import '@terra-js/terra-kit';

const getElementOffset = (elem) => {
    const box = elem.getBoundingClientRect();
    const body = document.body;
    const docEl = document.documentElement;
    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
    const clientTop = docEl.clientTop || body.clientTop || 0;
    const clientLeft = docEl.clientLeft || body.clientLeft || 0;
    const top = box.top + scrollTop - clientTop;
    const left = box.left + scrollLeft - clientLeft;
    return { top, left };
};
const getDateStringWithFormat = (dateString, format = 'HH:mm dd/MM/yyyy') => {
    try {
        return fnsFormat(new Date(dateString), format);
    }
    catch (_a) {
        return '';
    }
};
const getRemainingTime = (endDate) => {
    const remainingTime = (new Date(endDate).valueOf() - new Date().valueOf()) / 86400000;
    if (remainingTime <= 7 && remainingTime >= 0) {
        if (remainingTime >= 1) {
            return `${Math.floor(remainingTime)} ${t('ngày')}`;
        }
        else {
            const hours = Math.floor((new Date(endDate).valueOf() - new Date().valueOf()) / 3600000);
            if (hours >= 1) {
                return `${hours} ${t('giờ')}`;
            }
            else {
                return `1 ${t('giờ')}`;
            }
        }
    }
    return undefined;
};
const formatCurrency = (money) => {
    return money
        ? money.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
        : `${money}`;
};
const formatCurrencyFull = (money) => `${formatCurrency(money)}₫`;
const removeAccent = (string) => {
    let str = string;
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    str = str.replace(/ + /g, ' ');
    str = str.trim();
    return str;
};
const sortItems = (childItems) => {
    return childItems.sort((left, right) => left.displayPriority > right.displayPriority ? 1 : -1);
};
const getComboName = (childItems) => {
    if (childItems.length === 0)
        return '';
    const primary = sortItems(childItems)[0];
    const comboLength = childItems.length;
    return comboLength === 1
        ? primary.name
        : t('{{PrimaryName}} và {{var0}} sản phẩm khác', {
            PrimaryName: primary.name,
            var0: comboLength - 1,
        });
};
const getComboImageUrl = (childItems) => {
    if (childItems.length === 0)
        return [];
    return sortItems(childItems).map((item) => { var _a, _b; return item.imageUrl || ((_b = (_a = item.product) === null || _a === void 0 ? void 0 : _a.productInfo) === null || _b === void 0 ? void 0 : _b.imageUrl); });
};

export { formatCurrency, formatCurrencyFull, getComboImageUrl, getComboName, getDateStringWithFormat, getElementOffset, getRemainingTime, removeAccent };
